import { logger } from '#utils';
import videojs, { EnhancedVideoJsPlayer } from 'video.js';
import restorePlayerVolume from '#modules/player/util/restorePlayerVolume';

export const triggerPlayerPlay = () => {
  const player = getPlayerInstance();

  if (player && player.paused()) {
    handlePlayerPlay(player);
  }
};

export const getPlayerInstance = () => {
  const playerElement = videojs.dom.$('.video-js');

  if (!playerElement) {
    return null;
  }

  return videojs(playerElement) as EnhancedVideoJsPlayer;
};

export const handlePlayerPlay = (player: EnhancedVideoJsPlayer) => {
  const playPromise = player.play();
  if (playPromise !== undefined) {
    playPromise.catch(() => {
      handlePlayerPlayRetry(player);
    });
  }
};

export const handlePlayerPlayRetry = (player: EnhancedVideoJsPlayer) => {
  logger.info('Retry player play - muted');

  player.addClass('player-muted');
  player.muted(true);

  const retryPlayPromise = player.play();
  if (retryPlayPromise !== undefined) {
    retryPlayPromise
      .catch(() => {
        logger.warn('Player play blocked');
      })
      .finally(() => {
        restorePlayerVolume(player);
        player.removeClass('player-muted');
      });
  } else {
    logger.warn('Missing undefined promise.');
  }
};
